import { useState, useEffect } from 'react';

// Breakpoints mirror layout.css @media rules — keep in sync if CSS changes.
const DESKTOP_QUERY =
  '(min-width: 1025px), (orientation: landscape) and (min-width: 568px) and (max-width: 1024px)';

const matchesDesktop = (): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(DESKTOP_QUERY).matches
    : false;

export const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState(matchesDesktop);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(DESKTOP_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isDesktop;
};
